export const services = [
  {
    id: 1,
    title: "Web Development",
    description: "Creating modern, responsive web applications using React, Node.js, and latest technologies.",
    icon: "🌐",
    technologies: ["React", "Node.js", "JavaScript", "HTML/CSS"]
  },
  {
    id: 2,
    title: "DevOps & CI/CD",
    description: "Setting up robust deployment pipelines, automation, and infrastructure management.",
    icon: "⚙️",
    technologies: ["Docker", "GitHub Actions", "AWS", "Linux"]
  },
  {
    id: 3,
    title: "Mobile Development",
    description: "Cross-platform mobile applications using React Native and modern frameworks.",
    icon: "📱",
    technologies: ["React Native", "Expo", "JavaScript", "Redux"]
  }
];
